import { useState, useEffect, useRef } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function CryptoInsights() {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [selectedSymbol, setSelectedSymbol] = useState("Bitcoin");
    const [isWaiting, setIsWaiting] = useState(false);
    const chatBodyRef = useRef(null);

    useEffect(() => {
        if (chatBodyRef.current) {
            chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
        }
    }, [messages]);

    const sendMessage = async () => {
        if (input.trim() === "") return;
    
        const userMessage = { text: `[${selectedSymbol}] ${input}`, sender: "user" };
        setMessages([...messages, userMessage]);
        setInput("");
        setIsWaiting(true);
    
        try {
            const response = await fetch("https://crypto-price-prediction.nugenesisou.com/chat", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    symbol: selectedSymbol.toLowerCase(), // Dynamically selected symbol
                    message: input,
                    historical_data: true,
                    prediction_data: true
                })
            });
    
            const data = await response.json();
            const botMessage = { text: `[${selectedSymbol}] ${data.response || "Sorry, I couldn't fetch the data."}`, sender: "bot" };
            
            setMessages((prevMessages) => [...prevMessages, botMessage]);
        } catch (error) {
            console.error("Error fetching data:", error);
            setMessages((prevMessages) => [...prevMessages, { text: `[${selectedSymbol}] An error occurred. Please try again.`, sender: "bot" }]);
        } finally {
            setIsWaiting(false);
        }
    };
    
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Crypto Insights Bot</span>
                    </div>
                </section>

                <section class="security-hero not-min-height">
                <div data-lavalamp=""></div>
                <div data-lavalamp=""></div>
                    <div class="content">
                        <div class="pad texts full-width">
                            <h1><b>Crypto Insights Bot</b></h1>
                            <div class="text">
                            Crypto Insights Bot is your AI-powered assistant for navigating the volatile world of cryptocurrency markets. Leveraging advanced algorithms, real-time data analysis, and sentiment tracking, this bot provides accurate price predictions, trend analysis, and actionable trading insights.
                            </div>
                        </div>
                    </div>
                </section>

                <section class="pad security-hero">
                    <div class="content">
                        <div class="seer-chat-container">
                            <div class="chat-body" id="chat-body" ref={chatBodyRef}>
                                {messages.map((msg, index) => (
                                    <div key={index} class={`chat-message ${msg.sender}-message`}>
                                        {msg.text}
                                    </div>
                                ))}
                                {isWaiting && <div class="chat-message bot-message">Typing...</div>}
                            </div>
                            <div class="chat-input">
                                <select 
                                    value={selectedSymbol} 
                                    onChange={(e) => setSelectedSymbol(e.target.value)}
                                >
                                    <option value="Bitcoin">Bitcoin</option>
                                    <option value="Ethereum">Ethereum</option>
                                    <option value="Cardano">ADA (Cardano)</option>
                                    <option value="Solana">Solana</option>
                                    <option value="Dogecoin">Dogecoin (DOGE)</option>
                                    <option value="Tron">TRON (TRX)</option>
                                    <option value="Litecoin">Litecoin</option>
                                    <option value="Decentraland">MANA</option>
                                    <option value="Shiba">Shiba Inu (SHIB)</option>
                                </select>
                                <input 
                                    type="text" 
                                    id="user-input" 
                                    placeholder="Type a message..." 
                                    value={input} 
                                    onChange={(e) => setInput(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                                    disabled={isWaiting}
                                />
                                <button onClick={sendMessage} disabled={isWaiting}>Send</button>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
